(ns ui.editor2.modal-download
  "Modal Dialog for downloading the story in the editor2."
  (:require [parts.replicant.query :as query]
            [vire.adserver.config :as cfg]))

(def download-poll-query
  {:query/kind :query/download-poll})

(defn spinner
  []
  [:div.flex.items-center.justify-center
   [:svg.animate-spin.h-8.w-8.text-blue-600
    {:xmlns "http://www.w3.org/2000/svg"
     :fill "none"
     :viewBox "0 0 24 24"}
    [:circle {:class "opacity-25" :cx "12" :cy "12" :r "10" :stroke "currentColor" :strokeWidth "4"}]
    [:path {:class "opacity-75" :fill "currentColor" :d "M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"}]]])

(defn panel
  [state]
  (let [result (query/get-result state
                                 (assoc download-poll-query
                                   :query/data (get-in state [:ui/modal :params])))
        download-params (:download/params result)
        story-type (:type download-params)
        blob-id (get-in download-params [:instagram.story.image/blob
                                         :blob/id])
        prev-blob-id (get-in download-params [:instagram.story.image.preview/blob
                                              :blob/id])
        video-blob-id (get-in download-params [:instagram.video/blob
                                         :blob/id])
        video-prev-blob-id (get-in download-params [:instagram.video.preview/blob
                                                    :blob/id])
        download-blob (or blob-id
                          video-blob-id)]

    [:div.flex.items-center.justify-center.flex-col
     {:replicant/key :download}
     [:div.flex.items-center
      [:div.relative.transform.overflow-hidden.px-4.pb-4.pt-5.text-left.transition-all.sm:my-8.sm:w-full.sm:max-w-lg.sm:p-6

       (if (or blob-id
               video-blob-id)
         ;; Download Ready
         [:div.flex.flex-col.items-center.space-y-6

          ;; Header section with icon and title
          [:div.flex.flex-col.items-center.text-center.space-y-3

           [:div.flex.items-center
            [:div.flex.size-16.shrink-0.items-center.justify-center.rounded-full.bg-green-100.sm:size-14
             [:svg.size-8.text-green-600
              {:fill "none" :viewBox "0 0 24 24" :stroke-width "1.5" :stroke "currentColor" :aria-hidden "true"}
              [:path {:stroke-linecap "round" :stroke-linejoin "round" :d "M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"}]]]
            [:h3.text-xl.font-bold.text-gray-900.ml-2
             "Your Story is Ready!"]]
           [:div.space-y-1
            [:p.text-sm.text-gray-600
             "Click the download button below to save your story to your device."]]]

          [:div.flex.flex-col.items-center.space-y-4
           [:div.text-center
            [:div.relative.rounded-lg.overflow-hidden.shadow-lg
             (if video-blob-id
               [:video
                {:style {:height "400px"}
                 :controls true
                 :loop true
                 :muted true
                 :autoPlay true
                 :poster (str (cfg/server) "/blob/" video-prev-blob-id)
                 :src (str (cfg/server) "/blob/" video-blob-id)}]

               [:img {:src (str (cfg/server) "/image/" prev-blob-id)
                      :style {:width "280px" :height "auto"}
                      :alt "Story preview"}])]]]

          [:div.flex.flex-col.items-center.space-y-3
           [:button.inline-flex.items-center.justify-center.rounded-lg.bg-gradient-to-r.from-blue-600.to-blue-700.px-8.py-4.text-base.font-semibold.text-white.shadow-lg.hover:from-blue-700.hover:to-blue-800.focus:outline-none.focus:ring-4.focus:ring-blue-500.focus:ring-offset-2.transition-all.duration-200.transform.hover:scale-105
            {:type "button"
             :on {:click [[:url/download (str (cfg/server) "/blob/" download-blob) "Story"]]}}
            [:svg.mr-2.size-5
             {:fill "none" :viewBox "0 0 24 24" :stroke-width "2" :stroke "currentColor"}
             [:path {:stroke-linecap "round" :stroke-linejoin "round" :d "M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"}]]
            "Download Story"]]]

         ;; Rendering in progress - Enhanced waiting screen
         [:div
          ;; CSS for progress animation
          [:style
           "@keyframes progress-indeterminate {
             0% { transform: translateX(-100%); }
             50% { transform: translateX(0%); }
             100% { transform: translateX(100%); }
           }"]
          
          [:div.flex.justify-center.items-center.mt-6.mb-4
           (spinner)]
          
          [:div.text-center.mb-4
           [:h4.text-lg.font-medium.text-gray-900.mb-2
            "Rendering Your Story"]
           [:p.text-sm.text-gray-600
            "We're currently processing and rendering your story. This usually takes just a few moments."]]
          
          [:div.w-full.max-w-md.mx-auto
           [:div.w-full.bg-gray-200.rounded-full.h-2.overflow-hidden
            [:div.h-2.bg-blue-500.rounded-full
             {:style {:width "100%"
                      :animation "progress-indeterminate 2s ease-in-out infinite"}}]]]
          
          [:div.text-center.mt-4
           [:p.text-xs.text-gray-500
            "Please don't close this window while we're working on your story."]
           ]])]]]))

(defn render [state]
  [:div
   (panel state)])

(def modal
  {:modal-id :modal/download
   :on-load (fn [location]
              [[:data/query (assoc download-poll-query
                              :query/data (get-in location [:ui/modal :params]))]])
   :render #'render})